import { Component, Input, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AppService } from '@root/app.service';
import { SwitchPageService } from '@root/router/component/order-detail-sidebar/switch-page.service';
import { ModalService } from '@root/router/index/modal.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { filter } from 'rxjs';
import { RateService } from './rate.service';
import { MultiHouseCalendarService } from '../../calendar/multi-house-calendar/multi-house-calendar.service';

enum Status {
  Unrate_Both = 0, // 双方都未评
  Unrate_Host = 1, // 房东未评
  Unrate_Guest = 2, // 房客未评
  Rate_Both = 3, // 互评，待回复
  Complete = 7, // 完成
}

@Component({
  selector: 'host-rate-detail',
  templateUrl: './rate-detail.component.html',
  styleUrls: ['./rate-detail.component.scss'],
})
export class RateDetailComponent implements OnInit {
  readonly Status: typeof Status = Status;
  @Input() code;
  rateDetail;

  constructor(
    private switchPageService: SwitchPageService,
    private globalModalService: ModalService,
    private rateService: RateService,
    private drawerRef: NzDrawerRef,
    // private international: InternationalService,
    private app: AppService,
    private router: Router,
    private deprecatedCalendarSrv: MultiHouseCalendarService
  ) {}

  get isInternational(): boolean {
    return this.app.app.international;
    // return this.international.isInternational();
  }

  get unsupportedRateChannel() {
    return this.rateDetail && this.rateDetail.display_type === 'simple';
  }

  get threadId() {
    return this.rateDetail?.thread_id;
  }

  ngOnInit() {
    console.log('code: ', this.code);
    this.fetchRateDetail();

    this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => this.drawerRef.close());
  }

  fetchRateDetail() {
    this.rateService.fetchRateDetail({ reservation_order_code: this.code }).subscribe((res) => {
      console.log('res, ', res);
      this.rateDetail = res.data;
    });
  }

  requestSetRated(role) {
    this.rateService
      .setCommentComplete({
        reservation_order_code: this.code,
        role,
      })
      .subscribe((rst) => {
        if (rst.error_code === 0) {
          this.fetchRateDetail();
        }
      });
  }

  // back () {
  //   this.switchPageService.back();
  // }

  close() {
    this.drawerRef.close();
    // this.switchPageService.go(0);
  }

  displayRateModal() {
    const modal = this.globalModalService.displayRateModal({ code: this.code });
    modal.afterClose.subscribe((r) => this.fetchRateDetail());
  }

  displayRateReplyModal() {
    const modal = this.globalModalService.displayRateReplyModal({ code: this.code });
    modal.afterClose.subscribe((r) => this.fetchRateDetail());
  }

  onClickSetRated(role: 'host' | 'guest') {
    this.requestSetRated(role);
  }

  onClickViewReservation() {
    this.deprecatedCalendarSrv.selectReservation(this.code);
  }
}
